import { EventEmitter } from 'events';

import envConfig from '../../static/config';
import AppDispatcher from '../dispatcher/AppDispatcher';
import { requestLastLoginDetails } from '../utils/LastLoginApiUtils';
import { CHANGE_EVENT } from '../constants/AppConstants';
import {
  DISMISS_LAST_LOGIN_ALERT,
  INIT_LAST_LOGIN_ALERT,
  INIT_LAST_LOGIN_ALERT_SUCCESS,
  REQUEST_LAST_LOGIN_DETAILS,
  REQUEST_LAST_LOGIN_DETAILS_ERROR,
  REQUEST_LAST_LOGIN_DETAILS_SUCCESS,
} from '../constants/LastLoginConstants';

let _details = null;
let _isAlertInitialised = false;
let _shouldRenderAlert = false;
let _isRequestError = false;

class LastLoginStore extends EventEmitter {
  constructor() {
    super();
    this.dispatchToken = AppDispatcher.register(
      this.dispatcherCallback.bind(this)
    );
  }

  emitChange() {
    this.emit(CHANGE_EVENT);
  }

  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  }

  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
    clearTimeout(this.delayedAlertRequest);
  }

  resetStore() {
    _details = null;
    _isAlertInitialised = false;
    _shouldRenderAlert = false;
    _isRequestError = false;
  }

  _saveDetails(data) {
    if (!data || (typeof data === 'object' && Object.keys(data).length === 0)) {
      _details = null;
      return;
    }

    _details = {
      loginDate: data.login_date,
      platformType: (data.platform_type ?? '').toUpperCase(),
      platformDetails: data.platform_details,
    };
  }

  getDetails() {
    return _details;
  }

  isAlertInitialised() {
    return _isAlertInitialised;
  }

  shouldRenderAlert() {
    return _shouldRenderAlert;
  }

  isRequestError() {
    return _isRequestError;
  }

  dispatcherCallback(data) {
    const {
      action: { actionType, data: actionData },
    } = data;

    switch (actionType) {
      case DISMISS_LAST_LOGIN_ALERT:
        _shouldRenderAlert = false;
        _details = null;

        this.emitChange();
        break;

      case INIT_LAST_LOGIN_ALERT:
        _isAlertInitialised = true;

        /**
         * Additional init delay to allow the stored procedure to finish.
         * Caused by poor backend performance and enforced by Solution Design spec.
         */
        this.delayedAlertRequest = setTimeout(() => {
          requestLastLoginDetails({ isAlert: true });
        }, envConfig.lastLogin.initAlertDelay);

        break;

      case INIT_LAST_LOGIN_ALERT_SUCCESS:
        this._saveDetails(actionData);

        if (_details) {
          _shouldRenderAlert = true;
        }

        this.emitChange();
        break;

      case REQUEST_LAST_LOGIN_DETAILS:
        if (_isRequestError) {
          _isRequestError = false;
        }

        requestLastLoginDetails();
        break;

      case REQUEST_LAST_LOGIN_DETAILS_SUCCESS:
        this._saveDetails(actionData);

        this.emitChange();
        break;

      case REQUEST_LAST_LOGIN_DETAILS_ERROR:
        _isRequestError = true;
        this.emitChange();

        break;

      default: {
        break;
      }
    }
  }
}

export default new LastLoginStore();
